import { default as ShortDescriptionFieldWrapper } from './ShortDescriptionFieldWrapper';

export default ShortDescriptionFieldWrapper;
